import React from 'react';
import { useEffect } from 'react';
import useFetchObjectByPost from '../../../components/Hooks/useFetchObjectByPost';
import { sto } from '../../../Context/InshData';
import { uri } from '../../../help/Api';
import PaymentTransactionRPT from './paymentTransactionRPT';

const defaultAutos ={
  Safes:[],
}

export default function PaymentTransactionRPTCon() {


      const tb1 = {
                  wait:true,
                  Branches:true,
                  AccountsIndex:true,
                  omlat: true,
                  Users:true,
                  stor:sto,
                  parms:{filtr: true, pcode: 0, },
            }
        const {object: AutoOptions, fetching:fetchAll} = useFetchObjectByPost(uri+'Rept',tb1); 
        
        useEffect(()=>{
          console.log("loc al ", AutoOptions)
        })

  if(  fetchAll || !AutoOptions?.Branches )
    return <></>

  return (
  <PaymentTransactionRPT {...{
    AutoOptions: AutoOptions?.Branches? {...AutoOptions, 
      Accindex: AutoOptions.Accindex?.filter(ac => ac.id.toString().toLowerCase().startsWith('123') || ac.id.toString().toLowerCase().startsWith('261') || ac.id == -1)}
      : defaultAutos,
  } 
  }/>
  );




};